module.exports = __webpack_public_path__ + "static/media/lightcarbon.bc216cb0.png";